import Notebook from './Notebook'

export default Notebook
